import React from 'react';
import { LayoutDashboardIcon, BotIcon, UsersIcon, ShieldCheckIcon, TrendingUpIcon, MessageCircleIcon, AlertTriangleIcon, HeartHandshakeIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-271">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-272">
        <div className="text-center mb-16" data-id="element-273">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-274">
            Built for Real Families
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-275">
            Powerful tools designed to bring your family together around digital
            safety
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-276">
          {/* Family Dashboard */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-277">
            <div className="flex items-center mb-6" data-id="element-278">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-279">
                <LayoutDashboardIcon className="w-6 h-6 text-[#631bb7]" data-id="element-280" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-281">
                The Family Dashboard
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-282">
              A unified view of your entire family's security posture. See
              everyone's progress at a glance.
            </p>
            <div className="space-y-4" data-id="element-283">
              <div className="flex items-start" data-id="element-284">
                <TrendingUpIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-285" />
                <div data-id="element-286">
                  <span className="font-semibold text-[#111111]" data-id="element-287">
                    Family Security Score
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-288">
                    See your family's overall protection level
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-289">
                <UsersIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-290" />
                <div data-id="element-291">
                  <span className="font-semibold text-[#111111]" data-id="element-292">
                    Individual Progress
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-293">
                    Track each family member's learning journey
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-294">
                <ShieldCheckIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-295" />
                <div data-id="element-296">
                  <span className="font-semibold text-[#111111]" data-id="element-297">
                    Coordinated Protection
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-298">
                    Shared guides prevent costly mistakes
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* AI Security Coach */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-299">
            <div className="flex items-center mb-6" data-id="element-300">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-301">
                <BotIcon className="w-6 h-6 text-[#631bb7]" data-id="element-302" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-303">
                Your Security Coach
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-304">
              Patient, brilliant, and kind — like Mr. Rogers meets an Apple
              Genius.
            </p>
            <div className="space-y-4" data-id="element-305">
              <div className="flex items-start" data-id="element-306">
                <MessageCircleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-307" />
                <div data-id="element-308">
                  <span className="font-semibold text-[#111111]" data-id="element-309">
                    Plain English Help
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-310">
                    No jargon, just practical guidance
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-311">
                <AlertTriangleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-312" />
                <div data-id="element-313">
                  <span className="font-semibold text-[#111111]" data-id="element-314">
                    Proactive Alerts
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-315">
                    Identifies issues before they become problems
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-316">
                <HeartHandshakeIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-317" />
                <div data-id="element-318">
                  <span className="font-semibold text-[#111111]" data-id="element-319">
                    Human Support
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-320">
                    Real people when you need them
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Learning Center Preview */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-321">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8" data-id="element-322">
            <div data-id="element-323">
              <h3 className="text-2xl font-bold text-[#111111] mb-2" data-id="element-324">
                The Learning Center
              </h3>
              <p className="text-gray-600" data-id="element-325">
                39 educational modules across three skill levels
              </p>
            </div>
            <a href="/learning-center" className="mt-4 md:mt-0 text-[#631bb7] font-semibold hover:underline" data-id="element-326">
              Explore All Modules →
            </a>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-327">
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-328">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-329">
                LEVEL 1 • ESSENTIALS
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-330">
                9 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-331">
                Passwords, Scams & Phishing, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-332">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-333">
                LEVEL 2 • INTERMEDIATE
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-334">
                11 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-335">
                Financial Accounts, Cloud Storage, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-336">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-337">
                SPECIALIZED GUIDES
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-338">
                19 Deep Dives
              </div>
              <p className="text-sm text-gray-600" data-id="element-339">
                AI Primer, Digital Legacy, and more
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}